
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"45","height":"34","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.78 32.297a3.867 3.867 0 002.73 1.133h36.306a3.867 3.867 0 003.862-3.864V4.15A3.867 3.867 0 0040.816.286H4.51A3.867 3.867 0 00.648 4.15v25.418a3.867 3.867 0 001.132 2.73zm38.951-1.148H4.596c2.52-2.4 9.463-8.967 13.945-12.815.543.5 1.034.943 1.433 1.3a3.857 3.857 0 005.378 0l.52-.47.915-.83C31.26 22.177 38.209 28.75 40.73 31.15zm1.667-1.56c-2.455-2.34-9.339-8.852-13.91-12.8l.002-.004a7199.4 7199.4 0 0013.909-12.7v25.503zM2.932 4.09V29.588c2.457-2.34 9.343-8.859 13.911-12.8A6557.214 6557.214 0 012.932 4.09zM21.5 17.937c-2.398-2.159-8.375-7.61-16.853-15.367h36.03l-.279.255c-3.202 2.928-13.065 11.95-16.575 15.112a1.588 1.588 0 01-2.324 0z","fill":"#fff"}})])
          )
        }
      }
    